import { FC } from "react";
import { Box, Spacer } from "@smile2impress/components/relaunch";
import { UTSLocale } from "@smile2impress/attraction-constants";
import { useUTSLocaleContext } from "context/utsLocaleContext";

import { kebabCase } from "utils/kebabCase";
import { removeDiacritics } from "utils/removeDiacritics";
import { filterCitiesByFlagship } from "utils/clinics/filterCitiesByFlagship";

import { CityGrid } from "../CityGrid";
import {
    CitiesListProps,
    LOCALE_WITH_TWO_CITY_LISTS,
} from "./CitiesList.types";

export const CitiesList: FC<CitiesListProps> = ({
    titleForFirstList,
    titleForSecondList,
    disclaimerForSecondList,
    cities,
    excludedCities = [],
}) => {
    const { locale } = useUTSLocaleContext();

    const filteredCities = cities.filter(
        (origCity) =>
            !excludedCities.includes(
                kebabCase(removeDiacritics(origCity.title))
            )
    );

    if (!filteredCities.length) return <></>;

    const showTwoLists = LOCALE_WITH_TWO_CITY_LISTS.includes(locale);
    const citiesWithFlaghipClinics = filterCitiesByFlagship(
        filteredCities,
        true
    );
    const citiesWithoutFlaghipClinics = filterCitiesByFlagship(
        filteredCities,
        false
    );

    return (
        <Box px={[0, 0, 4]} mb={5}>
            {showTwoLists ? (
                <>
                    <CityGrid
                        title={titleForFirstList}
                        cities={citiesWithFlaghipClinics}
                        showFlagshipBadge={locale !== UTSLocale.GB_EN}
                    />
                    {titleForSecondList &&
                        citiesWithoutFlaghipClinics.length > 0 && (
                            <>
                                <Spacer mt={[4, 4, 5]} />
                                <CityGrid
                                    title={titleForSecondList}
                                    disclaimer={disclaimerForSecondList}
                                    cities={citiesWithoutFlaghipClinics}
                                    showInfoText
                                />
                            </>
                        )}
                </>
            ) : (
                <CityGrid
                    title={titleForFirstList}
                    cities={filteredCities}
                    showFlagshipBadge
                />
            )}
        </Box>
    );
};
